import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, catchError, finalize, tap } from 'rxjs';
import { RequestsService } from 'src/app/services/requests.service';
import { FormData } from 'src/app/interfaces/form-data';
import { ConfirmWithdrawComponent } from '../confirm-withdraw/confirm-withdraw.component';
import { SpinnerService } from 'src/app/services/spinner.service';
import { HandlerSnackbarService } from 'src/app/services/handler-snackbar.service';
import {
  faCheckCircle,
  faTimesCircle,
} from '@fortawesome/free-solid-svg-icons';
@Component({
  selector: 'app-request-info',
  templateUrl: './request-info.component.html',
})
export class RequestInfoComponent implements OnInit {
  @Input() info: any;
  @Input() title!: string;
  @Input() hasWithdrawModal: boolean = false;

  request: any;
  active = 1;
  faCheckCircle = faCheckCircle;
  faTimesCircle = faTimesCircle;
  formData: FormData | undefined;
  pending$: Observable<any> = new Observable<any>();
  constructor(
    public modalService: NgbModal,
    public requestService: RequestsService,
    public spinnerService: SpinnerService,
    public errorService: HandlerSnackbarService
  ) { }

  ngOnInit(): void {
    this.spinnerService.open();
    this.requestService
      .getRequest(this.info.id)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          this.spinnerService.close();
          return this.errorService.handlerErrorSubscribe(error);
        })
      )
      .subscribe((data: any) => {
        this.request = data;
        this.formData = data.form;
        this.spinnerService.close();
      });
    this.pending$ = this.requestService.getHistory(this.info.id).pipe(
      tap(() => this.spinnerService.open()),
      catchError((error: HttpErrorResponse) => {
        return this.errorService.handlerErrorSubscribe(error);
      }),
      finalize(() => this.spinnerService.close())
    );
  }

  closeModal() {
    this.modalService.dismissAll();
  }

  withdrawModal() {
    this.closeModal();
    const modalRef = this.modalService.open(ConfirmWithdrawComponent, {
      size: 'md',
      centered: true,
    });
    modalRef.result.then(
      (result) => {
        if (result) {
          this.requestService
            .withdrawRequest(result.id)
            .pipe(
              catchError((error: HttpErrorResponse) => {
                return this.errorService.handlerErrorSubscribe(error);
              })
            )
            .subscribe((data: any) => {
              console.log(data);
            });
        }
      },
      (error) => {
        console.log(error);
      }
    );

    modalRef.componentInstance.info = this.request;
  }

  onEvent(eventName: any, $event: any) {
    console.log('(' + eventName + ')', $event);
  }
}